import { render, staticRenderFns } from "./IndicatorDetails.vue?vue&type=template&id=35958abc&scoped=true&"
import script from "./IndicatorDetails.vue?vue&type=script&lang=js&"
export * from "./IndicatorDetails.vue?vue&type=script&lang=js&"
import style0 from "./IndicatorDetails.vue?vue&type=style&index=0&id=35958abc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35958abc",
  null
  
)

export default component.exports